// *********************************
// CoolGames Builder JavaScript file
// *********************************
export var EventSystem = {
    _subscribers: {},
    /**
     * Subscribe to an event.
     *
     * @param {*} eventId The id of the event to subscribe to.
     * @param {*} eventCallback A bound function that is called when the event is dispatched.
     */
    subscribe: function (eventId, eventCallback) {
        if (!this._subscribers[eventId]) {
            this._subscribers[eventId] = [];
        }
        for (var i = 0; i < this._subscribers[eventId].length; i++) {
            if (this._subscribers[eventId][i] === eventCallback) {
                throw new Error("EventSystem: already subscribed to this event: " + eventId);
            }
        }
        this._subscribers[eventId].push(eventCallback);
    },
    /**
     * Unsubscribe from an event.
     *
     * @param {*} eventId The event id to unsubscribe from.
     * @param {*} eventCallback A reference to the callback.
     */
    unsubscribe: function (eventId, eventCallback) {
        if (this._subscribers[eventId]) {
            for (var i = 0; i < this._subscribers[eventId].length; i++) {
                if (this._subscribers[eventId][i] === eventCallback) {
                    this._subscribers[eventId].splice(i, 1);
                    return;
                }
            }
        }
        console.error("EventSystem: event doesn't exist");
    },
    /**
     * Dispatch an event with any number of arguments. Arguments after the first are used for all called callbacks.
     *
     * @param {*} eventId The event id to dispatch
     */
    dispatch: function (eventId) {
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        if (!this._subscribers[eventId]) {
            return;
        }
        for (var i = 0; i < this._subscribers[eventId].length; i++) {
            this._subscribers[eventId][i].apply(null, args);
        }
    }
};
